import React from 'react';
import classNames from 'classnames';
import {EmblaIcon} from '../../emblaIcon/emblaIcon';
import {EmblaIconsType} from "../../../emblaIcons";

type ReactTableContextMenuButtonProps = {
    label: string;
    icon: EmblaIconsType;
    onClick: () => void;
};

const ReactTableContextMenuButton = ({label, icon, onClick}: ReactTableContextMenuButtonProps) => (
    <button
        className={classNames("btn btn-svg border-0 shadow-none d-flex flex-space tooltip-hover-line align-items-center")}
        onClick={onClick}>
        <label style={{cursor: 'pointer'}}>{label}</label>
        <EmblaIcon
            iconName={icon}
            additionalClasses="small"/>
    </button>
);

export default ReactTableContextMenuButton;
